import { TimePeriod } from '@shared/api/types';

export function getMonthlyPeriodsInWindow(
  allPeriods: TimePeriod[] | undefined,
  windowStartDate: string | undefined,
  windowEndDate: string | undefined
): TimePeriod[] {
  if (!allPeriods || !windowStartDate || !windowEndDate) return [];
  return allPeriods
    .filter(
      (period) =>
        period.type === 'month' &&
        period.startDate >= windowStartDate &&
        period.endDate <= windowEndDate
    )
    .sort((a, b) => a.startDate.localeCompare(b.startDate));
}
